import { defineComponent as o, computed as f } from "vue";
import { sortSizes as c } from "./td-longtail-vue-components282.js";
import l from "./td-longtail-vue-components266.js";
const u = /* @__PURE__ */ o({
  __name: "offer-tile-variant",
  props: {
    variants: { default: void 0 },
    type: null,
    limit: { default: void 0 }
  },
  emits: ["select-variant"],
  setup(n) {
    const t = n, s = f(() => {
      if (!t.variants || t.variants.length === 0) return [];
      const i = (t.type === "SIZE" ? c(t.variants) : t.variants).filter((r) => r.name !== "");
      if (!t.limit)
        return i;
      const a = i.find((r) => r.active), e = i.filter((r) => !r.active).slice(0, t.limit);
      return a ? [a, ...e] : e;
    });
    return { __sfc: !0, props: t, mappedVariants: s, VariantSelector: l };
  }
});
export {
  u as default
};
